"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var previewH5Urls = {
  localtest: 'https://localtest.api.fucaiyijia.com/pages/activity/skin_activity/index',
  vir: 'https://vir.h5.fucaiyijia.com/pages/activity/skin_activity/index',
  pre: 'https://pre.api.fucaiyijia.com/pages/activity/skin_activity/index',
  prod: 'https://h5.fucaiyijia.com/pages/activity/skin_activity/index'
};
function getPreviewH5Url() {
  var adminApiUrl = String(process.env.VUE_APP_BASE_API || '').toLowerCase();
  var currentHost = typeof window !== 'undefined' ? String(window.location.hostname || '').toLowerCase() : '';
  var envSource = "".concat(adminApiUrl, " ").concat(currentHost);
  if (envSource.includes('localtest.')) return previewH5Urls.localtest;
  if (envSource.includes('vir.')) return previewH5Urls.vir;
  if (envSource.includes('pre.')) return previewH5Urls.pre;
  if (envSource.includes('admin.fucaiyijia.com')) return previewH5Urls.prod;
  return process.env.NODE_ENV === 'development' ? previewH5Urls.localtest : previewH5Urls.prod;
}
function getPreviewUrl() {
  var iframeUrl = getPreviewH5Url();
  var separator = iframeUrl.includes('?') ? '&' : '?';
  return "".concat(iframeUrl).concat(separator, "d=").concat(Date.now());
}
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      visibleDrawer: false,
      //是否为展开
      listLoading: true,
      submitInfo: {},
      previewUrl: getPreviewUrl()
    };
  },
  props: {
    showType: {
      type: [Number, String],
      default: 1 // 1: 点击预览 2：直接预览
    }
  },
  mounted: function mounted() {
    // Initialize the helper script for rights exchange button
    this.injectHelperScript();
  },
  methods: {
    throttle: _throttle.default,
    // 预览
    previewSetting: function previewSetting() {
      var _document$getElementB,
        _this = this;
      var submitInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isPreview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.visibleDrawer = true;
      this.submitInfo = _objectSpread({}, submitInfo);
      // 点预览强制刷新iframe
      if ((_document$getElementB = document.getElementById("materialList")) !== null && _document$getElementB !== void 0 && _document$getElementB.src && isPreview) {
        document.getElementById("materialList").src = this.previewUrl;
      }
      // iframe消息发送
      setTimeout(function () {
        _this.sendMsg();
      }, isPreview ? 1000 : 0);
    },
    sendMsg: function sendMsg() {
      var _this2 = this,
        _document$getElementB2,
        _document$getElementB3;
      // Process component data before sending to iframe
      var processedInfo = _objectSpread({}, this.submitInfo);

      // If componentList exists, process each component
      if (processedInfo.componentList && Array.isArray(processedInfo.componentList)) {
        processedInfo.componentList = processedInfo.componentList.map(function (component) {
          return _this2.processComponentData(component);
        });
      }
      (_document$getElementB2 = document.getElementById("materialList")) === null || _document$getElementB2 === void 0 ? void 0 : (_document$getElementB3 = _document$getElementB2.contentWindow) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.postMessage({
        type: "hswwPreview",
        info: processedInfo
      }, "*");
    },
    processComponentData: function processComponentData(component) {
      // Create a copy of the component to avoid modifying the original
      var processedComponent = JSON.parse(JSON.stringify(component));

      // If this is a rights exchange button (showType === 14)
      if (processedComponent.showType === 14 || processedComponent.adapter && processedComponent.adapter.type === 'rights_exchange_button') {
        // Make sure the component has a unique id
        if (!processedComponent.id) {
          processedComponent.id = 'rights_exchange_' + Date.now();
        }

        // Ensure all style properties are included
        var styleProps = {
          // Button text content
          buttonText: processedComponent.buttonText || '确认兑换',
          // Text position (1 = left, 2 = center, 3 = right)
          textPosition: processedComponent.textPosition || 1,
          // Theme color (text color)
          themeColor: processedComponent.themeColor || '#1989fa',
          // Dimensions
          buttonWidth: processedComponent.buttonWidth || 120,
          buttonHeight: processedComponent.buttonHeight || 44,
          // Corner settings
          cornerType: processedComponent.cornerType || 1,
          borderRadius: processedComponent.borderRadius || 4,
          // Background
          bgImg: processedComponent.bgImg || '',
          bgPic: processedComponent.bgPic || '',
          bgColor: processedComponent.bgColor || '#1989fa',
          // Margin settings
          marginType: processedComponent.marginType || 1,
          margin: processedComponent.margin || 0
        };

        // Merge the style properties into the processed component
        Object.assign(processedComponent, styleProps);
      }
      return processedComponent;
    },
    // IRAME 加载完的时间
    loadIframe: function loadIframe() {
      this.injectHelperScript();
      this.sendMsg();
    },
    closeDrawer: function closeDrawer() {
      this.visibleDrawer = false;
    },
    // 注入辅助脚本，用于渲染权益兑换按钮
    injectHelperScript: function injectHelperScript() {
      var helperScript = "\n\t\t\t\t(function() {\n\t\t\t\t\t// \u786E\u4FDD\u4E0D\u4F1A\u91CD\u590D\u6CE8\u5165\n\t\t\t\t\tif (window.__rightsExchangeHelperInjected) {\n\t\t\t\t\t\tconsole.log('\u6743\u76CA\u5151\u6362\u8F85\u52A9\u811A\u672C\u5DF2\u6CE8\u5165\uFF0C\u8DF3\u8FC7');\n\t\t\t\t\t\treturn;\n\t\t\t\t\t}\n\n\t\t\t\t\tconsole.log('\u6B63\u5728\u6CE8\u5165\u6743\u76CA\u5151\u6362\u6309\u94AE\u6E32\u67D3\u811A\u672C...');\n\t\t\t\t\twindow.__rightsExchangeHelperInjected = true;\n\n\t\t\t\t\t// \u5B58\u50A8\u6E32\u67D3\u7684\u6309\u94AE\u6620\u5C04\n\t\t\t\t\twindow.__renderedRightsButtons = {};\n\n\t\t\t\t\t// \u6E32\u67D3\u6743\u76CA\u5151\u6362\u6309\u94AE\u7684\u51FD\u6570\n\t\t\t\t\twindow.renderRightsExchangeButton = function(component) {\n\t\t\t\t\t\tconst buttonId = Date.now();\n\t\t\t\t\t\tconsole.log('\u6E32\u67D3\u6743\u76CA\u5151\u6362\u6309\u94AE:', component);\n\n\t\t\t\t\t\t// \u521B\u5EFA\u6309\u94AE\u7684\u7236\u5BB9\u5668\n\t\t\t\t\t\tconst containerID = 'rights-btn-container-' + buttonId;\n\t\t\t\t\t\tconst buttonContainer = document.createElement('div');\n\t\t\t\t\t\tbuttonContainer.id = containerID;\n\t\t\t\t\t\tbuttonContainer.style.position = 'fixed';\n\t\t\t\t\t\tbuttonContainer.style.bottom = '50px';\n\t\t\t\t\t\tbuttonContainer.style.left = '0';\n\t\t\t\t\t\tbuttonContainer.style.width = '100%';\n\t\t\t\t\t\tbuttonContainer.style.display = 'flex';\n\t\t\t\t\t\tbuttonContainer.style.alignItems = 'center';\n\t\t\t\t\t\tbuttonContainer.style.zIndex = '999';\n\n\t\t\t\t\t\t// \u6839\u636E\u6587\u5B57\u4F4D\u7F6E\u8BBE\u7F6E\u6837\u5F0F\n\t\t\t\t\t\t// 1 = \u5DE6, 2 = \u4E2D, 3 = \u53F3\n\t\t\t\t\t\tswitch (parseInt(component.textPosition) || 1) {\n\t\t\t\t\t\t\tcase 1:\n\t\t\t\t\t\t\t\tbuttonContainer.style.justifyContent = 'flex-start';\n\t\t\t\t\t\t\t\tbuttonContainer.style.paddingLeft = '10px';\n\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\tcase 2:\n\t\t\t\t\t\t\t\tbuttonContainer.style.justifyContent = 'center';\n\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\tcase 3:\n\t\t\t\t\t\t\t\tbuttonContainer.style.justifyContent = 'flex-end';\n\t\t\t\t\t\t\t\tbuttonContainer.style.paddingRight = '10px';\n\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\tdefault:\n\t\t\t\t\t\t\t\tbuttonContainer.style.justifyContent = 'flex-start';\n\t\t\t\t\t\t\t\tbuttonContainer.style.paddingLeft = '10px';\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t// \u521B\u5EFA\u6309\u94AE\n\t\t\t\t\t\tconst button = document.createElement('div');\n\t\t\t\t\t\tbutton.id = 'rights-exchange-button-' + buttonId;\n\t\t\t\t\t\tbutton.innerText = component.buttonText || '\u786E\u8BA4\u5151\u6362';\n\t\t\t\t\t\tbutton.style.cursor = 'pointer';\n\t\t\t\t\t\tbutton.style.userSelect = 'none';\n\t\t\t\t\t\tbutton.style.boxSizing = 'border-box';\n\t\t\t\t\t\tbutton.style.textAlign = 'center';\n\t\t\t\t\t\tbutton.style.lineHeight = (component.buttonHeight || 44) + 'px';\n\t\t\t\t\t\tbutton.style.fontSize = '16px';\n\n\t\t\t\t\t\t// \u5E94\u7528\u6309\u94AE\u5C3A\u5BF8\n\t\t\t\t\t\tbutton.style.width = (component.buttonWidth || 120) + 'px';\n\t\t\t\t\t\tbutton.style.height = (component.buttonHeight || 44) + 'px';\n\n\t\t\t\t\t\t// \u5E94\u7528\u6587\u672C\u5BF9\u9F50\n\t\t\t\t\t\tbutton.style.display = 'flex';\n\t\t\t\t\t\tbutton.style.alignItems = 'center';\n\t\t\t\t\t\tbutton.style.justifyContent = 'center';\n\n\t\t\t\t\t\t// \u5E94\u7528\u6587\u5B57\u989C\u8272\n\t\t\t\t\t\tbutton.style.color = component.themeColor || '#FFFFFF';\n\n\t\t\t\t\t\t// \u5E94\u7528\u5706\u89D2\n\t\t\t\t\t\tif (component.cornerType === 1) {\n\t\t\t\t\t\t\t// \u7EDF\u4E00\u8BBE\u7F6E\u5706\u89D2\n\t\t\t\t\t\t\tbutton.style.borderRadius = (component.borderRadius || 4) + 'px';\n\t\t\t\t\t\t} else if (component.cornerType === 2) {\n\t\t\t\t\t\t\t// \u5206\u5F00\u8BBE\u7F6E\uFF08\u652F\u6301\u524D\u7AEF\u66F4\u65B0\u540E\u7684\u5206\u5F00\u8BBE\u7F6E\u529F\u80FD\uFF09\n\t\t\t\t\t\t\tconst tl = component.borderRadiusTopLeft || component.borderRadius || 4;\n\t\t\t\t\t\t\tconst tr = component.borderRadiusTopRight || component.borderRadius || 4;\n\t\t\t\t\t\t\tconst br = component.borderRadiusBottomRight || component.borderRadius || 4;\n\t\t\t\t\t\t\tconst bl = component.borderRadiusBottomLeft || component.borderRadius || 4;\n\t\t\t\t\t\t\tbutton.style.borderRadius = tl + 'px ' + tr + 'px ' + br + 'px ' + bl + 'px';\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t// \u5E94\u7528\u80CC\u666F - \u4F18\u5148\u4F7F\u7528\u80CC\u666F\u56FE\u7247\n\t\t\t\t\t\tif (component.bgImg && component.bgImg.trim() !== '') {\n\t\t\t\t\t\t\tbutton.style.backgroundImage = 'url(' + component.bgImg + ')';\n\t\t\t\t\t\t\tbutton.style.backgroundSize = 'cover';\n\t\t\t\t\t\t\tbutton.style.backgroundPosition = 'center';\n\t\t\t\t\t\t}\n\t\t\t\t\t\t// \u5176\u6B21\u4F7F\u7528\u80CC\u666F\u56FE\u72472\n\t\t\t\t\t\telse if (component.bgPic && component.bgPic.trim() !== '') {\n\t\t\t\t\t\t\tbutton.style.backgroundImage = 'url(' + component.bgPic + ')';\n\t\t\t\t\t\t\tbutton.style.backgroundSize = 'cover';\n\t\t\t\t\t\t\tbutton.style.backgroundPosition = 'center';\n\t\t\t\t\t\t}\n\t\t\t\t\t\t// \u6700\u540E\u4F7F\u7528\u80CC\u666F\u989C\u8272\n\t\t\t\t\t\telse {\n\t\t\t\t\t\t\tbutton.style.backgroundColor = component.bgColor || '#1989fa';\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t// \u5E94\u7528\u8FB9\u6846\n\t\t\t\t\t\tbutton.style.border = 'none';\n\n\t\t\t\t\t\t// \u5E94\u7528\u5916\u8FB9\u8DDD\n\t\t\t\t\t\tif (component.marginType === 1) {\n\t\t\t\t\t\t\t// \u7EDF\u4E00\u8BBE\u7F6E\u5916\u8FB9\u8DDD\n\t\t\t\t\t\t\tconst margin = component.margin || 0;\n\t\t\t\t\t\t\tbutton.style.margin = margin + 'px';\n\t\t\t\t\t\t} else if (component.marginType === 2) {\n\t\t\t\t\t\t\t// \u5206\u5F00\u8BBE\u7F6E\uFF08\u652F\u6301\u524D\u7AEF\u66F4\u65B0\u540E\u7684\u5206\u5F00\u8BBE\u7F6E\u529F\u80FD\uFF09\n\t\t\t\t\t\t\tconst mt = component.marginTop || component.margin || 0;\n\t\t\t\t\t\t\tconst mr = component.marginRight || component.margin || 0;\n\t\t\t\t\t\t\tconst mb = component.marginBottom || component.margin || 0;\n\t\t\t\t\t\t\tconst ml = component.marginLeft || component.margin || 0;\n\t\t\t\t\t\t\tbutton.style.margin = mt + 'px ' + mr + 'px ' + mb + 'px ' + ml + 'px';\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t// \u6DFB\u52A0\u70B9\u51FB\u5904\u7406\u7A0B\u5E8F\n\t\t\t\t\t\tbutton.addEventListener('click', function() {\n\t\t\t\t\t\t\tconsole.log('\u6743\u76CA\u5151\u6362\u6309\u94AE\u88AB\u70B9\u51FB');\n\n\t\t\t\t\t\t\t// \u5411\u7236\u7A97\u53E3\u53D1\u9001\u6D88\u606F\n\t\t\t\t\t\t\twindow.parent.postMessage({\n\t\t\t\t\t\t\t\ttype: 'RIGHTS_EXCHANGE_BUTTON_CLICKED',\n\t\t\t\t\t\t\t\tbuttonId: buttonId,\n\t\t\t\t\t\t\t\tcomponent: component\n\t\t\t\t\t\t\t}, '*');\n\t\t\t\t\t\t});\n\n\t\t\t\t\t\t// \u5C06\u6309\u94AE\u6DFB\u52A0\u5230\u5BB9\u5668\n\t\t\t\t\t\tbuttonContainer.appendChild(button);\n\n\t\t\t\t\t\t// \u5C1D\u8BD5\u6DFB\u52A0\u5230\u9875\u9762\n\t\t\t\t\t\tdocument.body.appendChild(buttonContainer);\n\t\t\t\t\t\tconsole.log('\u6309\u94AE\u5DF2\u6DFB\u52A0\u5230\u9875\u9762');\n\n\t\t\t\t\t\t// \u5B58\u50A8\u6309\u94AE\u5F15\u7528\n\t\t\t\t\t\twindow.__renderedRightsButtons[buttonId] = {\n\t\t\t\t\t\t\tcomponent: component,\n\t\t\t\t\t\t\telement: button,\n\t\t\t\t\t\t\tcontainer: buttonContainer\n\t\t\t\t\t\t};\n\n\t\t\t\t\t\treturn buttonId;\n\t\t\t\t\t};\n\n\t\t\t\t\t// \u79FB\u9664\u6743\u76CA\u5151\u6362\u6309\u94AE\u7684\u51FD\u6570\n\t\t\t\t\twindow.removeRightsExchangeButton = function(buttonId) {\n\t\t\t\t\t\tif (window.__renderedRightsButtons[buttonId]) {\n\t\t\t\t\t\t\tconst container = document.getElementById('rights-btn-container-' + buttonId);\n\t\t\t\t\t\t\tif (container) {\n\t\t\t\t\t\t\t\tcontainer.remove();\n\t\t\t\t\t\t\t\tconsole.log('\u5DF2\u79FB\u9664\u6743\u76CA\u5151\u6362\u6309\u94AE:', buttonId);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tdelete window.__renderedRightsButtons[buttonId];\n\t\t\t\t\t\t\treturn true;\n\t\t\t\t\t\t}\n\t\t\t\t\t\treturn false;\n\t\t\t\t\t};\n\n\t\t\t\t\t// \u76D1\u542C\u6765\u81EA\u7236\u7A97\u53E3\u7684\u6D88\u606F\n\t\t\t\t\twindow.addEventListener('message', function(event) {\n\t\t\t\t\t\tif (event.data.type === 'hswwPreview') {\n\t\t\t\t\t\t\tconsole.log('\u6536\u5230\u9884\u89C8\u6570\u636E:', event.data);\n\n\t\t\t\t\t\t\tconst components = event.data.info.componentList || [];\n\n\t\t\t\t\t\t\t// \u6E05\u9664\u73B0\u6709\u6309\u94AE\n\t\t\t\t\t\t\tif (window.__renderedRightsButtons) {\n\t\t\t\t\t\t\t\tObject.keys(window.__renderedRightsButtons).forEach(id => {\n\t\t\t\t\t\t\t\t\twindow.removeRightsExchangeButton(id);\n\t\t\t\t\t\t\t\t});\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t// \u4E3A\u6743\u76CA\u5151\u6362\u7EC4\u4EF6\u6E32\u67D3\u6309\u94AE\n\t\t\t\t\t\t\tcomponents.forEach(component => {\n\t\t\t\t\t\t\t\tif (component.showType === 14 ||\n\t\t\t\t\t\t\t\t\t(component.adapter && component.adapter.type === 'rights_exchange_button')) {\n\t\t\t\t\t\t\t\t\twindow.renderRightsExchangeButton(component);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t});\n\t\t\t\t\t\t}\n\t\t\t\t\t});\n\n\t\t\t\t\t// \u901A\u77E5\u7236\u7A97\u53E3\u811A\u672C\u5DF2\u6210\u529F\u6CE8\u5165\n\t\t\t\t\twindow.parent.postMessage({\n\t\t\t\t\t\ttype: 'HELPER_SCRIPT_INJECTED'\n\t\t\t\t\t}, '*');\n\t\t\t\t})();\n\t\t\t";
      try {
        var iframe = document.getElementById("materialList");
        if (!iframe || !iframe.contentWindow || !iframe.contentWindow.document) {
          console.error('找不到iframe或其document');
          return;
        }

        // 检查是否已经注入了辅助脚本
        if (iframe.contentWindow.document.getElementById('rights-exchange-helper')) {
          console.log('辅助脚本已经注入，无需重复注入');
          return;
        }

        // 创建脚本元素
        var script = iframe.contentWindow.document.createElement('script');
        script.id = 'rights-exchange-helper';
        script.textContent = helperScript;

        // 将脚本添加到iframe文档
        iframe.contentWindow.document.head.appendChild(script);
        console.log('权益兑换辅助脚本注入成功');
      } catch (error) {
        console.error('通过DOM注入辅助脚本失败', error);
        console.log('尝试使用postMessage进行脚本注入');

        // 使用postMessage作为备选方案
        try {
          var _iframe = document.getElementById("materialList");
          if (_iframe && _iframe.contentWindow) {
            // 通过postMessage发送脚本内容
            _iframe.contentWindow.postMessage({
              type: 'SCRIPT_INJECTION',
              scriptContent: helperScript
            }, '*');

            // 添加一次性侦听器以获取响应
            var _responseHandler = function responseHandler(event) {
              if (event.data && event.data.type === 'SCRIPT_INJECTION_RESPONSE') {
                console.log('通过postMessage进行脚本注入' + (event.data.success ? '成功' : '失败'));
                window.removeEventListener('message', _responseHandler);
              }
            };
            window.addEventListener('message', _responseHandler);
          }
        } catch (postMessageError) {
          console.error('使用postMessage进行脚本注入失败', postMessageError);
        }
      }
    }
  }
};